import { render } from "./venue-sidebar.vue?vue&type=template&id=8ea9ee18"
import script from "./venue-sidebar.vue?vue&type=script&lang=js"
export * from "./venue-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__